export default {"src":"/_next/static/media/icon-ytb.cb1a3852.svg","height":16,"width":16};